module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('nav', {
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page-ix"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('ol', {
    staticClass: "none",
    attrs: {
      "epub:type": "list"
    }
  }, [_c('li', {
    staticClass: "toc-preface",
    attrs: {
      "id": "toc-cover"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-front"
  }, [_c('span', {
    attrs: {
      "href": "#/titlepage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-preface",
    attrs: {
      "id": "toc-welcome"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/welcome",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Welcome")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-preface",
    attrs: {
      "id": "toc-copyright"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-preface",
    attrs: {
      "id": "toc-dedication"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-preface",
    attrs: {
      "id": "toc-preface002"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/preface002"
    }
  }, [_vm._v("Publisher’s Note")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-preface1",
    attrs: {
      "id": "toc-introduction"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/introduction"
    }
  }, [_c('strong', [_vm._v("Introduction: What to Do While We Wait for a Cure")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter1",
    attrs: {
      "id": "toc-chapter001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter001"
    }
  }, [_vm._v("1. Get Smart About "), _c('strong', [_vm._v("Alcohol")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter1",
    attrs: {
      "id": "toc-chapter002"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter002"
    }
  }, [_vm._v("2. Consider "), _c('strong', [_vm._v("Alpha Lipoic Acid and ALCAR")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter1",
    attrs: {
      "id": "toc-chapter003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Ask Questions About "), _c('strong', [_vm._v("Anesthesia")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter1",
    attrs: {
      "id": "toc-chapter004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Check Out Your "), _c('strong', [_vm._v("Ankle")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter1",
    attrs: {
      "id": "toc-chapter005"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Don’t Shy Away from "), _c('strong', [_vm._v("Antibiotics")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter1",
    attrs: {
      "id": "toc-chapter006"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Eat "), _c('strong', [_vm._v("Antioxidant-Rich Foods")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter1",
    attrs: {
      "id": "toc-chapter007"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Know About the "), _c('strong', [_vm._v("ApoE4 Gene")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter1",
    attrs: {
      "id": "toc-chapter008"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Drink "), _c('strong', [_vm._v("Apple Juice")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter1",
    attrs: {
      "id": "toc-chapter009"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Beware of "), _c('strong', [_vm._v("Bad Fats")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter010"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Keep Your "), _c('strong', [_vm._v("Balance")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter011"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter011",
      "id": "page-x",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Eat "), _c('strong', [_vm._v("Berries")]), _vm._v(" Every Day")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter012"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Grow a "), _c('strong', [_vm._v("Bigger Brain")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter013"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Control "), _c('strong', [_vm._v("Blood Pressure")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter014"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Get a Quick "), _c('strong', [_vm._v("Blood-Sugar Test")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter015"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Be a "), _c('strong', [_vm._v("Busy Body")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter016"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. Don’t Be Afraid of "), _c('strong', [_vm._v("Caffeine")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter017"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Count "), _c('strong', [_vm._v("Calories")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter018"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. Watch Out for "), _c('strong', [_vm._v("Celiac Disease")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter019"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. Treat Yourself to "), _c('strong', [_vm._v("Chocolate")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter020"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. Control Bad "), _c('strong', [_vm._v("Cholesterol")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter021"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. Eat "), _c('strong', [_vm._v("Choline-Rich Foods")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter022"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. Go Crazy for "), _c('strong', [_vm._v("Cinnamon")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter023"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. Say Yes to "), _c('strong', [_vm._v("Coffee")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter024"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24. Build "), _c('strong', [_vm._v("“Cognitive Reserve”")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter025"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25. Be "), _c('strong', [_vm._v("Conscientious")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter026"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26. Keep "), _c('strong', [_vm._v("Copper and Iron")]), _vm._v(" Out of Your Brain")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter027"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27. Eat "), _c('strong', [_vm._v("Curry")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter028"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28. Try the "), _c('strong', [_vm._v("DASH Diet")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter029"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29. Overcome "), _c('strong', [_vm._v("Depression")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter030"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30. Prevent and Control "), _c('strong', [_vm._v("Diabetes")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter031"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter031",
      "id": "page-xi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31. Get the Right "), _c('strong', [_vm._v("Diagnosis")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter032"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32. Know the "), _c('strong', [_vm._v("Early Signs of Alzheimer’s")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter033"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33. Be "), _c('strong', [_vm._v("Easygoing and Upbeat")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter034"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34. Get a Higher "), _c('strong', [_vm._v("Education")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter035"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35. Avoid "), _c('strong', [_vm._v("Environmental Toxins")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter036"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36. Know the "), _c('strong', [_vm._v("Estrogen")]), _vm._v(" Evidence")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter037"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37. Enjoy "), _c('strong', [_vm._v("Exercise")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter038"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38. Be an "), _c('strong', [_vm._v("Extrovert")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter039"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39. Have Your "), _c('strong', [_vm._v("Eyes")]), _vm._v(" Checked")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter040"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter040",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40. Know the Dangers of "), _c('strong', [_vm._v("Fast Foods")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter041"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41. Yes, Yes, Yes—Eat "), _c('strong', [_vm._v("Fatty Fish")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter042"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42. Take "), _c('strong', [_vm._v("Folic Acid")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter043"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43. Eat a Low-"), _c('strong', [_vm._v("Glycemic Diet")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter044"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44. "), _c('strong', [_vm._v("Google")]), _vm._v(" Something")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter045"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45. Raise Your Good "), _c('strong', [_vm._v("HDL Cholesterol")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter046"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46. Guard Against "), _c('strong', [_vm._v("Head Injury")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter047"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47. Be Good to Your "), _c('strong', [_vm._v("Heart")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter048"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48. Keep "), _c('strong', [_vm._v("Homocysteine")]), _vm._v(" Normal")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter049"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49. Avoid "), _c('strong', [_vm._v("Inactivity")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter050"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50. Try to Keep "), _c('strong', [_vm._v("Infections")]), _vm._v(" Away")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter051"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter051",
      "id": "page-xii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51. Fight "), _c('strong', [_vm._v("Inflammation")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter052"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52. Find Good "), _c('strong', [_vm._v("Information")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter053"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53. Keep "), _c('strong', [_vm._v("Insulin")]), _vm._v(" Normal")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter054"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter054",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54. Have an Interesting "), _c('strong', [_vm._v("Job")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter055"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55. Drink "), _c('strong', [_vm._v("Juices")]), _vm._v(" of All Kinds")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter056"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter056",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56. Learn to Love "), _c('strong', [_vm._v("Language")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter057"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57. Avoid a "), _c('strong', [_vm._v("Leptin Deficiency")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter058"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter058",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58. Don’t Be "), _c('strong', [_vm._v("Lonely")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter059"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter059",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59. Embrace "), _c('strong', [_vm._v("Marriage")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter060"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter060",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60. Know the Dangers of "), _c('strong', [_vm._v("Meat")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter061"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter061",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61. Consider "), _c('strong', [_vm._v("Medical Marijuana")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter062"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62. Practice "), _c('strong', [_vm._v("Meditation")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter063"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter063",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63. Follow the "), _c('strong', [_vm._v("Mediterranean Diet")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter064"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter064",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64. Recognize "), _c('strong', [_vm._v("Memory Problems")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter065"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter065",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65. Keep "), _c('strong', [_vm._v("Mentally Active")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter066"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter066",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66. Take "), _c('strong', [_vm._v("Multivitamins")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter067"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter067",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67. Build Strong "), _c('strong', [_vm._v("Muscles")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter068"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter068",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68. Take a "), _c('strong', [_vm._v("Nature Hike")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter069"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter069",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69. Do Something "), _c('strong', [_vm._v("New")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter070"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter070",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70. Get Enough "), _c('strong', [_vm._v("Niacin")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter071"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter071",
      "id": "page-xiii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71. Think About a "), _c('strong', [_vm._v("Nicotine Patch")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter072"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter072",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72. Be Cautious About "), _c('strong', [_vm._v("NSAIDs")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter073"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter073",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73. Go Nuts over "), _c('strong', [_vm._v("Nuts")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter074"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter074",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74. Worry About Middle-Age "), _c('strong', [_vm._v("Obesity")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter075"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter075",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75. Get Help for "), _c('strong', [_vm._v("Obstructive Sleep Apnea")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter076"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter076",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76. Go for "), _c('strong', [_vm._v("Olive Oil")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter077"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter077",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77. Beware of "), _c('strong', [_vm._v("Omega-6 Fat")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter078"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter078",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78. Know Your "), _c('strong', [_vm._v("Plaques and Tangles")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter079"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter079",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79. Have a "), _c('strong', [_vm._v("Purpose in Life")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter080"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter080",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80. Get a Good Night’s "), _c('strong', [_vm._v("Sleep")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter081"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter081",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81. Forget About "), _c('strong', [_vm._v("Smoking")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter082"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter082",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82. Have a Big "), _c('strong', [_vm._v("Social Circle")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter083"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter083",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83. Don’t Forget Your "), _c('strong', [_vm._v("Spinach")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter084"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter084",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84. Investigate "), _c('strong', [_vm._v("Statins")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter085"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter085",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85. Surround Yourself with "), _c('strong', [_vm._v("Stimulation")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter086"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter086",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86. Deal with "), _c('strong', [_vm._v("Stress")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter087"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter087",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87. Avoid "), _c('strong', [_vm._v("Strokes")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter088"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter088",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88. Cut Down on "), _c('strong', [_vm._v("Sugar")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter089"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter089",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89. Drink "), _c('strong', [_vm._v("Tea")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter090"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter090",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90. Take Care of Your "), _c('strong', [_vm._v("Teeth")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter091"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter091",
      "id": "page-xiv",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91. Have Your "), _c('strong', [_vm._v("Thyroid")]), _vm._v(" Checked")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter092"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter092",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92. Beware of Being "), _c('strong', [_vm._v("Underweight")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter093"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter093",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93. Prevent "), _c('strong', [_vm._v("Vascular Dementia")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter094"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter094",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94. Play "), _c('strong', [_vm._v("Video Games")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter095"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter095",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95. Put "), _c('strong', [_vm._v("Vinegar")]), _vm._v(" in Everything")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter096"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter096",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96. Get Enough "), _c('strong', [_vm._v("Vitamin B"), _c('sub', [_vm._v("12")])])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter097"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter097",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97. Don’t Neglect "), _c('strong', [_vm._v("Vitamin D")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter098"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter098",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98. Watch Your "), _c('strong', [_vm._v("Waist")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter099"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter099",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99. "), _c('strong', [_vm._v("Walk, Walk, Walk")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chaptera",
    attrs: {
      "id": "toc-chapter100"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100. Make It "), _c('strong', [_vm._v("Wine,")]), _vm._v(" Preferably Red")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-appendix",
    attrs: {
      "id": "toc-appendix001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/appendix001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Putting It All Together: Your Anti-Alzheimer’s Plan")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-acknowledgements",
    attrs: {
      "id": "toc-acknowledgements"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/acknowledgements",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-appendix",
    attrs: {
      "id": "toc-appendix002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/appendix002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alzheimer’s Disease Centers")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-appendix",
    attrs: {
      "id": "toc-appendix003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/appendix003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Note on Scientific References")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-appendix",
    attrs: {
      "id": "toc-personblurb"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/personblurb",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-preface",
    attrs: {
      "id": "toc-praise"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/praise",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Praise of Jean Carper’s 100 Simple Things You Can Do to Prevent Alzheimer’s")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-appendix",
    attrs: {
      "id": "Newsletters"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/newsletterSignup",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Newsletters")])])])]), _vm._v(" "), _c('nav', {
    staticClass: "hidden-tag",
    attrs: {
      "epub:type": "landmarks",
      "hidden": "hidden"
    }
  }, [_c('h1', [_vm._v("Navigation")]), _vm._v(" "), _c('ol', {
    staticClass: "none",
    attrs: {
      "epub:type": "list"
    }
  }, [_c('li', [_c('span', {
    attrs: {
      "epub:type": "bodymatter",
      "href": "#/welcome",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Begin Reading")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "toc",
      "href": "#/toc"
    }
  }, [_vm._v("Table of Contents")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74aa95e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 69
// module chunks = 0